import React from 'react';
import { withRouter } from 'react-router-dom';
import { EContext } from './EContext';

declare global {
    interface Window {
        Intercom: any;
    }
}

const createSettings = profile => ({
    ...profile,
    hide_default_launcher: true,
    alignment: 'right',
    Url: window.location.href,
});

function Intercom({ children, location }: any) {
    const [visible, setVisibility] = React.useState(false);
    const { identity } = React.useContext(EContext);

    React.useEffect(() => {
        if (!window.Intercom) {
            const settings = createSettings(identity!.user.extra.intercomProfile);

            window.Intercom = function() {
                window.Intercom.c(arguments);
            };
            window.Intercom.q = [];
            window.Intercom.c = function(args) {
                window.Intercom.q.push(args);
            };

            const script = document.createElement('script');
            script.async = true;
            script.src = `https://widget.intercom.io/widget/${settings.app_id}`;
            script.onload = () => {
                window.Intercom('boot', settings);
                window.Intercom('onHide', () => setVisibility(false));
            };
            document.head.appendChild(script);
        }

        return () => {
            if (window.Intercom) {
                window.Intercom('shutdown');
            }
        };
    }, []);

    React.useEffect(() => {
        // the intercom request can block rendering and cause pauses when the url changes in quick succession,
        // only trigger the updpate when we're 'sure' the user is staying on the current page
        const timeout = setTimeout(() => {
            window.Intercom('update', { Url: window.location.href });
        }, 500);

        return () => {
            clearTimeout(timeout);
        };
    }, [location.pathname]);

    React.useEffect(() => {
        window.Intercom(visible ? 'show' : 'hide');
    }, [visible]);

    return children({
        toggle: () => setVisibility(!visible),
        show: () => setVisibility(true),
        hide: () => setVisibility(false),
    });
}

export function showIntercom() {
    window.Intercom('show');
}

export default withRouter(Intercom);
